import axios from 'axios'
// import { sentry } from './sentry'

const rosettaError = ({
  errorMessage,
  // errorType,
  // type,
  // tags = {},
  interrupt = false
  // ...params
}) => {
  // sentry.captureMessage(errorMessage, {
  //   tags: {
  //     errorType,
  //     type,
  //     ...tags
  //   },
  //   ...params
  // })

  console.log('%c Rosetta error: ', 'color: #AD3E4A', errorMessage)

  if (interrupt) throw new Error(errorMessage)
}

export const initError = params => {
  rosettaError({
    errorType: 'init',
    ...params
  })
}

export const apiError = name => error => {
  let errorMessage
  let extra = {}
  let tags = {}

  if (error.response) {
    const {
      data: { message },
      config,
      status
    } = error.response

    errorMessage = message || (status === 404 ? 'Not found' : 'Unknown error')
    tags = {
      baseURL: config.baseURL,
      status,
      name
    }
    extra = {
      url: config.url,
      method: config.method,
      payload: JSON.parse(config.data)
    }
  } else {
    if (axios.isCancel(error)) {
      // console.log('Request canceled')
      return
    }

    errorMessage = error.message
  }

  console.error({
    errorMessage,
    errorType: 'api',
    extra,
    tags
  })

  // rosettaError({ NOTE: Uncommenting temporarily, will be sent to AWS cloudwatch later
  //   errorMessage,
  //   errorType: 'api',
  //   extra,
  //   tags
  // })
}

export const queryError = params => {
  rosettaError({
    errorType: 'query',
    ...params
  })
}

export const commandError = params => {
  rosettaError({
    errorType: 'command',
    ...params
  })
}

export const renderError = params => {
  rosettaError({
    errorType: 'render',
    ...params
  })
}

export const parserError = params => {
  rosettaError({
    errorType: 'parser',
    ...params
  })
}

export const eventError = params => {
  rosettaError({
    errorType: 'event',
    ...params
  })
}
